// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ImageLightboxController from "./image_lightbox_controller"
application.register("image-lightbox", ImageLightboxController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import MarkdownToolbarController from "./markdown_toolbar_controller"
application.register("markdown-toolbar", MarkdownToolbarController)

import PostCategoriesController from "./post_categories_controller"
application.register("post-categories", PostCategoriesController)

import PostMetaController from "./post_meta_controller"
application.register("post-meta", PostMetaController)
